import React from 'react';
import { Segment, List, Button } from 'semantic-ui-react';

class NotificationSettings extends React.Component {

 constructor(props) {
   super(props);
   this.state = {
     loading: true
   };
 }

 renderSettingsItem = (actionKey, timestamp) => {
   const {channels, actions} = this.props;
   const chanId = actions[actionKey]['chanId'];
   const channel = channels[chanId]

   if(typeof chanId === 'undefined' || typeof channel === 'undefined')
   return

   const iconName = channel.logo
   const iconColor = channel.color
   const chanName = channel.name

   const date = new Date(parseInt(timestamp, 10)).toLocaleDateString();
  //  debugger
   return (
     <List.Item key={actionKey}>
       <List.Content floated='right'>
         <Button compact basic negative
           onClick={() => this.props.removeNotification(actionKey)}
           icon='delete' />
       </List.Content>
       <List.Icon style={{color: iconColor}} name={iconName} size='large' verticalAlign='middle' />
       <List.Content as='a'>
         <List.Header>{`${chanName}: ${actions[actionKey]['name']}`}</List.Header>
         <List.Description>{`Monitoring since: ${date}`}</List.Description>
       </List.Content>
     </List.Item>
   )
 };

  render() {
    const userNotiArr = Object.keys(this.props.userNotifications);
    return (
      <Segment attached='bottom' loading={this.props.loading}>
        <List divided relaxed>
          {
            (userNotiArr.length > 0)
            ? userNotiArr.map(acyKey => this.renderSettingsItem(acyKey, this.props.userNotifications[acyKey]))
            : <List.Item>
              <List.Icon name='info circle' color='blue' size='large' verticalAlign='middle' />
              <List.Content>
                <List.Header>You have no actions in your notification list.</List.Header>
                <List.Description>Click 'Notify Me' at any action's detail page.</List.Description>
              </List.Content>
              </List.Item>
          }
        </List>
      </Segment>
    );
  }

}

export default NotificationSettings;



// WEBPACK FOOTER //
// ./src/components/protected/NotificationSettings.js